<template>
  <div class="card tw-m-4">
    <div v-if="isLoading">
      <Loader />
    </div>
    <div>
      <div class="tw-pb-6 tw-mb-6 tw-border-b-[1px] tw-border-[#D5D5D5]">
        <h5 class="tw-text-[#050A13] tw-text-[20px] tw-font-[500]">
          Integrations and Connected apps
        </h5>
        <p class="tw-text-[#505050] tw-text-[14px] tw-mt-2">
          Add and manage your seller and PPC accounts. Once connected you can
          automate your product review requests, track your financial data and
          monitor your products.
        </p>
      </div>
      <div class="tw-flex tw-gap-8 tw-px-2 tw-justify-between">
        <div
          class="tw-w-[70%] tw-border-[1px] tw-border-[#AEAEAE] tw-px-4 tw-rounded-[5px]"
        >
          <div
            class="tw-border-b tw-border-[#d5d5d5] tw-flex tw-justify-between tw-items-center"
          >
            <div class="tw-flex tw-items-center tw-py-4 tw-gap-4">
              <div
                class="tw-rounded-[5px] tw-w-[40px] tw-h-[40px] tw-flex tw-items-center tw-justify-center"
              >
                <img
                  :src="getPlatformIcon()"
                  :alt="this.selectedPlugNPlayPlatform"
                  class="tw-w-[40px] tw-h-[40px]"
                />
              </div>
              <span class="tw-font-[500] tw-text-[#050A13] tw-capitalize">{{
                this.selectedPlugNPlayPlatform
              }}</span>
              <span
                class="tw-text-[#15803D] tw-bg-[#DCFCE7] tw-px-2 tw-py-1 tw-rounded-[5px] tw-text-[12px] tw-font-medium"
              >
                ● {{ accountList.length }} Accounts Connected
              </span>
            </div>
            <div
              class="tw-text-[#FF0000] tw-text-[14px] tw-font-medium hover:tw-underline tw-cursor-pointer"
              @click="handleDisconnect"
            >
              Disconnect
            </div>
          </div>
          <div class="tw-mt-6" v-if="accountList.length">
            <div class="tw-border tw-pb-4 tw-rounded-[5px] tw-border-[#d4d4d4]">
              <div
                class="tw-flex tw-justify-between tw-gap-3 tw-flex-wrap tw-items-center tw-bg-[#A1A1A10D] tw-p-4 tw-border-b tw-border-[#d4d4d4]"
              >
                <div class="tw-flex tw-items-center tw-gap-3">
                  <img
                    src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                    alt="Profile"
                    class="tw-h-8 tw-w-8 tw-rounded-full"
                  />
                  <span
                    class="tw-text-[#050A13] tw-text-[16px] tw-font-medium"
                    >{{ accountDetails.email }}</span
                  >
                  <span
                    class="tw-text-[#15803D] tw-font-medium tw-bg-[#DCFCE7] tw-px-2 tw-py-1 tw-rounded-[5px] tw-text-[12px]"
                  >
                    Connected
                  </span>
                </div>
                <div class="tw-relative  tw-max-w-xs tw-overflow-hidden">
                  <input
                    v-model="searchAccount"
                    placeholder="Search"
                    class="tw-border-[1px] tw-border-primary_brand tw-h-[36px] focus:tw-outline-none focus:tw-shadow-none focus:tw-border-primary_brand tw-rounded-[6px] tw-text-primary_brand tw-pl-3"
                  />
                  <div
                    class="tw-absolute tw-inset-y-0 tw-right-0 tw-rounded-[7px] tw-bg-primary_brand text-white tw-p-3 tw-flex tw-items-center tw-pointer-events-none"
                  >
                    <img src="/Icons_SVG/Search.svg" class="tw-h-4 tw-w-4 tw-filter tw-invert tw-brightness-200"/>
                  </div>
                </div>
              </div>

              <div class="tw-h-[350px] tw-pb-4 tw-overflow-auto">
                <div
                  v-for="account in filteredAccounts"
                  :key="account.account_id"
                >
                  <div
                    key="{index}"
                    class="tw-flex tw-justify-between tw-items-center tw-mx-4 tw-p-2 tw-border-b tw-border-[#d4d4d4] hover:tw-bg-gray-50"
                  >
                    <span class="tw-text-[#000000] tw-text-[14px]">{{
                      account.account_name
                    }}</span>
                    <button
                      v-if="account.is_default"
                      class="tw-bg-primary_brand tw-border_primary-brand tw-rounded-[5px] text-white tw-px-4 tw-py-2 tw-text-[14px] tw-font-[500]"
                    >
                      Selected
                    </button>
                    <button
                      v-else
                      class="tw-bg-transparent tw-text-primary_brand tw-border-0 tw-py-2 tw-px-4 tw-cursor-pointer hover:tw-underline focus:tw-shadow-none focus:tw-outline-none tw-text-[14px]"
                      @click="handleDefaultAccount(account)"
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div
            class="tw-w-full tw-rounded-[5px] tw-border tw-border-[#AEAEAE] tw-p-3"
          >
            <h2 class="tw-text-[#050A13] tw-text-[16px] tw-mb-3 tw-font-medium">
              Account Details
            </h2>

            <div class="tw-bg-[#0655591A] tw-rounded-[10px] tw-p-4 tw-mb-6">
              <ul
                class="list-disc tw-leading-[18px] tw-pl-6 tw-space-y-2 tw-text-[12px] tw-text-[#050A13]"
              >
                <li>
                  We will be using your username and password to get sellerID
                  and importing inventory.
                </li>
                <li>
                  For security purpose password will be encrypted and saved.
                </li>
              </ul>
            </div>

            <div class="tw-px-2">
              <p class="tw-text-[12px] tw-text-[#505050]">Account Name</p>
              <p class="tw-text-[14px] tw-text-[#050A13]">
                {{ accountDetails.name }}
              </p>

              <p class="tw-text-[12px] tw-text-[#505050]">Email</p>
              <p class="tw-text-[14px] tw-text-[#050A13]">
                {{ accountDetails.email }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <button class="primarycolor tw-mx-2 tw-mt-8" @click="handleSave()">
        Save
      </button>
      <button class="navigationButton" @click="handleBack()">Back</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Loader from "../../Components/Loader.vue";
import router from "../../../router";

export default {
  name: "Accounts",
  components: {
    Loader,
  },
  data: function () {
    return {
      accountList: [],
      accountDetails: [],
      isLoading: false,
      searchAccount: "",
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedPlugNPlayPlatform"]),
    filteredAccounts() {
      const search = this.searchAccount?.toLowerCase() || "";
      return this.accountList.filter((account) =>
        account.account_name.toLowerCase().includes(search)
      );
    },
  },
  mounted() {
    this.getPlatformList();
    this.getAccountDetails();
  },
  methods: {
    ...mapActions("DemoStore", ["setSelectedPlugNPlayPlatform"]),
    getPlatformIcon() {
      const imageMapper = {
        "Amazon Ads": "amazon_ads.svg",
        "Flipkart Ads": "flipkart_ads.svg",
      };
      return `/slate_svg/${imageMapper[this.selectedPlugNPlayPlatform]}`;
    },
    getPlatformList() {
      this.isLoading = true;
      const urlMapper = {
        "Amazon Ads": "/api/v1/amazon/getaccounts",
        "Flipkart Ads": "/api/v1/flipkart/getaccounts",
      };
      const url = urlMapper[this.selectedPlugNPlayPlatform];
      const payload = {
        key: this.selectedPlugNPlayPlatform
          .toLowerCase()
          .replace(/ads/i, "")
          .trim(),
      };
      this.$http
        .post(url, payload)
        .then((res) => {
          this.accountList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
    handleDefaultAccount(account) {
      this.isLoading = true;
      const urlMapper = {
        "Amazon Ads": "/api/v1/amazon/setdefault",
        "Flipkart Ads": "/api/v1/flipkart/setdefault",
      };
      const url = urlMapper[this.selectedPlugNPlayPlatform];
      let payload = {};
      if (this.selectedPlugNPlayPlatform == "Amazon Ads") {
        payload = {
          account_id: account.account_id,
          main_id: account.main_id,
        };
      } else {
        payload = { account_id: account.account_id };
      }
      this.$http
        .post(url, payload)
        .then((res) => {
          this.getPlatformList();
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
    handleDisconnect() {
      this.isLoading = true;
      const urlMapper = {
        "Amazon Ads": "/api/v1/amazon/disconnect",
        "Flipkart Ads": "/api/slate/flipkart/disconnect",
      };
      const url = urlMapper[this.selectedPlugNPlayPlatform];
      this.$http
        .post(url)
        .then((res) => {
          router.push("/connect-your-account");
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
    getAccountDetails() {
      const urlMapper = {
        "Amazon Ads": "amazon",
        "Flipkart Ads": "flipkart",
      };
      const url =
        "/api/v2/slate/profile?channel=" +
        urlMapper[this.selectedPlugNPlayPlatform];
      this.$http
        .get(url)
        .then((res) => {
          this.accountDetails = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleBack() {
      router.push("connect-your-account");
    },
    handleSave() {
      router.push("campaign-summary");
    },
  },
};
</script>
<style scoped>
.card {
  border-radius: 0.7rem;
  border: none;
  margin-bottom: 1rem;
  background: #fff;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
</style>
